
import React, { Component, Fragment, useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { authenticationService } from '../../jwt/_services';

import {
	Reports
} from '../../components/repair-option-management/';

class ReportsView extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;

    this.state = {
			currentUser,
	  };

		//this.handleMessage = this.handleMessage.bind(this);
		//this.testCall = this.testCall.bind(this);

  }

	componentDidMount() {

		//this.getData();
	}

	componentWillUnmount() {

	}


	render() {
		return (
			<div>
				<Row>
					<Col md="12">
						<Reports />
					</Col>
				</Row>
			</div>
		);
	}
}

export default ReportsView;
